export const inspectTable_1 = [
  {
    content: "1. 안전보건교육실시 여부",
    isChecked: "",
  },
  {
    content: "2. 산업안전보건법령 게시 여부",
    isChecked: "",
  },
  {
    content: "3. 안전인증 및 안전검사 실시 여부",
    isChecked: "",
  },
  {
    content: "4. 위험성평가 실시 여부",
    isChecked: "",
  },
  {
    content: "5. 작업환경측정 실시여부",
    isChecked: "",
  },
  {
    content: "6. 건강검진(일반/특수) 실시여부",
    isChecked: "",
  },
  {
    content: "7. 물질안전보건자료(MSDS)게시여부",
    isChecked: "",
  },
  {
    content: "8. 기타사항",
    isChecked: "",
    rowType: 'customContent',
    customType: '1',
    contentStyle: {'align-items': 'center', 'white-space': 'nowrap'}
  },
];

export const inspectTable_2 = [
  {
    title: "작업장 일반",
    content: "1. 작업장 및 이동통로 정리정돈 상태",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "2. 안전보건표지 부착 상태",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "3. 기계기구별 작업관련 안전수칙 부착여부",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "4. 작업장 조명, 온도, 환기 상태",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "5. 물질안전보건자료(MSDS) 게시 여부",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "6. 화학물질이 담긴 소분용기의 경고표지 부착 여부",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "7. 근로자 적정 보호구 착용 상태",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "8. 위험기계기구에 대한 방호장치 설치 여부",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "9. 추락위험을 방지할 수 있는 안전시설 설치 여부 (안전난간, 안전 덮개, 방호 울 등)",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "10. 작업장 현장에서 화기 취급 여부",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "11. 휴게시설 설치 및 관리상태",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "12. 응급구급함 관리상태",
    isChecked: "",
  },
  {
    title: "작업장 일반",
    content: "13. 기타사항",
    isChecked: "",
    rowType: 'customContent',
    customType: '1',
    contentStyle: {'align-items': 'center', 'white-space': 'nowrap'}
  },

  {
    title: "전기",
    content: "1. 누전차단기 설치 및 노후 배선 여부",
    isChecked: "",
  },
  {
    title: "전기",
    content: "2. 비접지 콘센트 및 문어발식 콘센트 사용 여부",
    isChecked: "",
  },
  {
    title: "전기",
    content: "3. 분전함 외함 접지 및 네임텍 부착 여부",
    isChecked: "",
  },
  {
    title: "전기",
    content: "4. 정전 및 활선 작업시의 안전조치 및 보호구 착용 여부",
    isChecked: "",
  },
  {
    title: "전기",
    content: "5. 기타사항",
    isChecked: "",
    rowType: 'customContent',
    customType: '1',
    contentStyle: {'align-items': 'center', 'white-space': 'nowrap'}
  },

  {
    title: "소방",
    content: "1. 소화기구 설치 여부 및 정기 점검 실시 여부",
    isChecked: "",
  },
  {
    title: "소방",
    content: "2. 비상경보, 유도등 상태 및 소화전 앞 물품 적재 여부",
    isChecked: "",
  },
  {
    title: "소방",
    content: "3. 위험물 저장 및 보관상태 적정 여부",
    isChecked: "",
  },
  {
    title: "소방",
    content: "4. 방화문 및 방화셔터 적정 관리 여부",
    isChecked: "",
  },
  {
    title: "소방",
    content: "5. 기타사항",
    isChecked: "",
    rowType: 'customContent',
    customType: '1',
    contentStyle: {'align-items': 'center', 'white-space': 'nowrap'}
  },

  {
    title: "중량물 취급시 위험예방",
    content: "1. 5kg 이상의 중량물 작업 시 중량과 무게중심 표지 부착",
    isChecked: "",
  },
  {
    title: "중량물 취급시 위험예방",
    content: "2. 중량물 작업 시 올바른 작업자세 및 작업도구 지급 여부",
    isChecked: "",
  },
  {
    title: "중량물 취급시 위험예방",
    content: "3. 기타사항",
    isChecked: "",
    rowType: 'customContent',
    customType: '1',
    contentStyle: {'align-items': 'center', 'white-space': 'nowrap'}
  },
];
